import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import http from "./utils/http.js";
import * as api from "./api/index.js";
import * as ElIcon from "@element-plus/icons-vue";
import { getCookie } from "./utils/token";
import "element-plus/theme-chalk/index.css";
import "@purge-icons/generated";
ElMessage.info = msg => ElMessage({
  type: "info",
  message: msg
});
ElMessage.warn = msg => ElMessage({
  type: "warning",
  message: msg
});
ElMessage.error = msg => ElMessage({
  type: "error",
  message: msg
});
ElMessage.success = msg => ElMessage({
  type: "success",
  message: msg
});
const app = createApp({});
http.requestHandler(config => {
  // 同源相对路径：经 nginx /api 代理到后端，开发/生产通用
  config.baseURL = "/";
  // 自动带 token（admin 登录后存 localStorage，供 adminAuth 接口使用；无 token 时跳过不影响其他接口）
  const token = getCookie("token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.token = token;
  }
});
// 挂载全局
app.config.globalProperties.$http = http;
app.config.globalProperties.$api = api;
for (const [key, component] of Object.entries(ElIcon)) {
  app.component(key, component);
}
createApp(App).use(router).mount("#app");

// import { createApp } from 'vue'
// import App from './App.vue'
// import router from './router'
// import http from './utils/http.js'
// import api from './api/index.js'
// import * as ElIcon from '@element-plus/icons-vue'
// import '@purge-icons/generated'

// const app = createApp({})

// http.requestHandler((config) => {
// 	config.baseURL = 'http://127.0.0.1:7001/';
// 	console.log(config, '=======config======');
// });
// // 挂载全局
// app.config.globalProperties.$http = http;
// app.config.globalProperties.$api = api;

// for (const [key, component] of Object.entries(ElIcon)) {
//   app.component(key, component)
// }

// createApp(App).use(router).mount('#app')